<template>
  <div v-if="sacrificeLog" class>
    <!-- header start -->
    <van-nav-bar
      title="祭品详情"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="giftDetailsPage">
      <div class="avatar">
        <van-image
          width="100%"
          height="100%"
          fit="contain"
          :src="sacrificeLog.AppSacrifice.SacrificePath"
        />
      </div>

      <div class="details">
        <p>名称: {{sacrificeLog.AppSacrifice.SacrificeName}}</p>
        <!-- <p>类别: 鲜花</p> -->
        <p>敬献者: {{sacrificeLog.NickName}}</p>
        <p>敬献时间: {{$moment(sacrificeLog.AddDateTime).format("YYYY.MM.DD")}}</p>
        <p>有效时间: {{sacrificeLog.EffectiveTime/24/60/60}}天</p>
        <p>剩余时间: {{sacrificeLog.SurplusTime}}</p>
      </div>

      <div class="btn-area">
        <van-button class="mybtn" :to="{path:'/PersonInfo', query:{id:sacrificeLog.MemberSerialNumber}}">礼尚往来</van-button>
        <p class="tips">进入孝爱天使的空间</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
	  id: 0,
	  sacrificeLog:null,
	  
    };
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
	},
	init(){
		var that = this;
		this.$store.dispatch({
			type:"GetSacrificeLogSacrificeLogById",
			id:that.id,
		}).then(res => {
			console.log(res);
			that.sacrificeLog = res;
		}, err => {})
	}
  },
  created(){
	  this.id = this.$route.query.id;
	  this.init();
  }

};
</script>

<style scoped>
.giftDetailsPage .avatar {
  background-color: #fff;
  padding: 30px;
  width: 100%;
  height: 215px;
}
.giftDetailsPage .details {
  padding: 30px 20%;
}
.giftDetailsPage .details p {
  font-size: 15px;
  color: #444;
  line-height: 1.7;
}
.btn-area {
  margin-top: 40px auto 20px;
  text-align: center;
}
.tips {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}
</style>
